export type Perfil = 'SUPER_ADMINISTRADOR' | 'ADMINISTRADOR' | 'ANALISTA' | 'USUARIO';

export type PerfilNome = 'Super Administrador' | 'Administrador' | 'Analista' | 'Usuário';

export const PERFIL_NOMES: Record<Perfil, PerfilNome> = {
  SUPER_ADMINISTRADOR: 'Super Administrador',
  ADMINISTRADOR: 'Administrador',
  ANALISTA: 'Analista',
  USUARIO: 'Usuário',
};

/** Do maior para o menor acesso. */
export const PERFIL_HIERARQUIA: readonly Perfil[] = [
  'SUPER_ADMINISTRADOR',
  'ADMINISTRADOR',
  'ANALISTA',
  'USUARIO',
];
